import React, { useState } from "react";
import PerformanceAnalysisChampionTabs from "./PerformanceAnalysisChampionTabs";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const PerformanceAnalysisChampionBreakdown = (props) => {
  const { getChampionImg, getChampionLoadingImg } = getRiotAssetsContext();
  const [map, setMap] = useState(0);
  const [champion, setChampion] = useState(0);
  let { summonersRiftTopThree, howlingAbyssTopThree } = props;
  summonersRiftTopThree = summonersRiftTopThree || [];
  howlingAbyssTopThree = howlingAbyssTopThree || [];
  const combinedData = [...summonersRiftTopThree, ...howlingAbyssTopThree];

  const tabCallback = (mapIndex, championIndex) => {
    setMap(mapIndex);
    setChampion(championIndex);
  };

  const tabsData = [];
  if (summonersRiftTopThree.length > 0) {
    tabsData.push({
      label: "SUMMONER'S RIFT",
      champions: summonersRiftTopThree.map((element) => {
        return element.championId;
      }),
      callback: tabCallback,
    });
  }

  if (howlingAbyssTopThree.length > 0) {
    tabsData.push({
      label: "HOWLING ABYSS",
      champions: howlingAbyssTopThree.map((element) => {
        return element.championId;
      }),
      callback: tabCallback,
    });
  }

  if (tabsData.length === 0) {
    return <div />;
  }

  const dataArray = [];

  combinedData.forEach((element) => {
    dataArray.push([
      {
        statValue: element.gamesPlayed,
        statLabel: "GAMES PLAYED",
        statIcon: "https://static.bigbrain.gg/assets/lol/performance_analysis/icons/all_roles_icon.svg",
      },
      {
        statValue: `${(element.winRate * 100).toFixed(1)}%`,
        statLabel: "WIN RATE",
        statIcon: "https://static.bigbrain.gg/assets/lol/performance_analysis/icons/victory_icon.svg",
      },
      {
        statValue: element.kda.toFixed(1),
        statLabel: "KDA",
        statIcon: "https://static.bigbrain.gg/assets/lol/performance_analysis/icons/two_sword_icon.svg",
      },
      {
        statValue: `${(element.percentTeamGold * 100).toFixed(1)}%`,
        statLabel: "% OF TEAM GOLD",
        statIcon: "https://static.bigbrain.gg/assets/lol/performance_analysis/icons/gold_icon.svg",
      },
      {
        statValue: `${(element.percentTeamDamage * 100).toFixed(1)}%`,
        statLabel: "% OF TEAM DAMAGE",
        statIcon: "https://static.bigbrain.gg/assets/lol/performance_analysis/icons/sword_icon.svg",
      },
      {
        statValue: element.diedToMost.deaths,
        statLabel: "DIED TO MOST",
        statIcon: getChampionImg(element.diedToMost.championId),
        iconType: "champion",
      },
      {
        statValue: element.killedMost.kills,
        statLabel: "KILLED MOST",
        statIcon: getChampionImg(element.killedMost.championId),
        iconType: "champion",
      },
      {
        statValue: element.lostAgainstMost.loses,
        statLabel: "LOST AGAINST MOST",
        statIcon: getChampionImg(element.lostAgainstMost.championId),
        iconType: "champion",
      },
      {
        statValue: element.wonAgainstMost.wins,
        statLabel: "WON AGAINST MOST",
        statIcon: getChampionImg(element.wonAgainstMost.championId),
        iconType: "champion",
      },
    ]);
  });
  const activeIndex = map * summonersRiftTopThree.length + champion;

  return (
    <div className="champion-breakdown">
      <div className="text-container">
        <div className="small-header">YOUR TOP 3</div>
        <div className="large-header">CHAMPION BREAKDOWN</div>
        <div className="basic-text">
          Here’s a breakdown of how you played your top three champions. Unless it’s your teammate’s fault, we’ve yet to record
          you missing a skillshot.
        </div>
      </div>
      <PerformanceAnalysisChampionTabs tabsData={tabsData} />
      <div className="champion-breakdown_table">
        <div className="champion-loading-image">
          <img src={getChampionLoadingImg(tabsData[map].champions[champion])} />
        </div>
        <div className="table-stats">
          {dataArray[activeIndex].map((data, index) => {
            return (
              <div key={index} className="champion-data">
                <div className="data-container">
                  <div className="data_value">{data.statValue}</div>
                  <div className="data_label">{data.statLabel}</div>
                </div>
                <div className="data_icon">
                  <img className={data.iconType === "champion" ? "champion-icon" : ""} src={data.statIcon} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PerformanceAnalysisChampionBreakdown;
